import React from 'react';

const MZ = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_85"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_85)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="#FDE300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0Z"
        fill="#007168"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4H21V5H0V4ZM0 10H21V11H0V10Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V15.033L10 7.5L0 0Z"
        fill="#D4062E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.378 8.75L1.908 9.523L2.188 7.886L1 6.726L2.643 6.489L3.378 5L4.112 6.49L5.755 6.727L4.565 7.887L4.847 9.523"
        fill="#FDE300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.28 6.384L2.634 6.03L4.754 8.152L4.402 8.505L2.28 6.385V6.384Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.755 6.384L4.402 6.03L2.28 8.152L2.634 8.505L4.754 6.385L4.755 6.384Z"
        fill="black"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default MZ;
